import type { PublicApiKey } from '@/apilib';
import type { createPanelHelpersApi } from './panelHelpersApi';

export const PanelHelpersApiKey: PublicApiKey<typeof createPanelHelpersApi> = {
  name: 'PanelHelpersApi',
  public: true,
};
